import { useLocation } from "react-router-dom";
import MobileBottomNav from '@/components/feature/MobileBottomNav';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">페이지를 찾을 수 없습니다</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">돌아가서 다시 시도해주세요</p>
      </div>
      <div className="md:hidden h-16"></div>
      <MobileBottomNav />
    </div>
  );
}